import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import { yupResolver } from '@hookform/resolvers/yup'
import { Grid } from '@mui/material'
import { PasswordInput } from '@components/inputs'
import { Button } from '@components/buttons'

import { resetPasswordSchema } from '@utils/schemas'

import { AuthCard } from '../../components/cards/AuthCard'
import { enqueueSnackbar } from '@state/reducers/alertReducer'
import { resetPassword } from '@state/thunks/authThunk'
import { useSelector } from '@state/store'
import { useQuery } from '../../hooks/useQuery'
import { Actions } from '@state/actions'

type Values = {
  newPassword: string
  confirmNewPassword: string
}

export default function ResetPassword({ location }: any) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const query = useQuery()
  const loading = useSelector(({ loading }) => loading[Actions.RESET_PASSWORD])
  const [id, setId] = useState<number>()
  const [resetPasswordUUID, setResetPasswordUUID] = useState('')
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<Values>({
    resolver: yupResolver(resetPasswordSchema),
  })

  const onSubmit = (value: Values) => {
    dispatch(
      resetPassword({
        id: id as number,
        body: {
          newPassword: value.newPassword,
          resetPasswordUUID,
        },
      }),
    )
  }

  useEffect(() => {
    if (location && location.search) {
      const resetUUID = query.get('resetUUID')
      const userId = query.get('userId')
      if (resetUUID && userId) {
        setResetPasswordUUID(resetUUID)
        setId(+userId)
      } else {
        dispatch(
          enqueueSnackbar({
            type: 'error',
            message: 'Invalid user informations',
          }),
        )
        navigate('/auth/login')
      }
    } else {
      navigate('/auth/login')
    }
  }, [dispatch, history, location, query, control, setValue])

  const Content = (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      component="form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid item xs={12} sm={12}>
        <PasswordInput
          name="newPassword"
          errors={errors}
          control={control}
          inputProps={{
            autoComplete: 'new-password',
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <PasswordInput
          name="confirmNewPassword"
          errors={errors}
          control={control}
          inputProps={{
            autoComplete: 'new-password',
          }}
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <Button
          type="submit"
          text="submit"
          loading={loading}
          fullWidth
          color="secondary"
          format
        />
      </Grid>
    </Grid>
  )

  return (
    <AuthCard>
      <AuthCard.Header title="forgotten-password" />
      <AuthCard.Content>{Content}</AuthCard.Content>
      <AuthCard.Actions backToLoginLink />
    </AuthCard>
  )
}
